import {httpBuildQuery, isEmpty} from "@helpers/helpers";
import md5 from "md5";
import {getFile} from "./media";
import {str_replace} from "../components/helpers/helpers";
import {$http} from "@http";
import {getCacheKey} from "./cache_key";

const cacheTable = 'agencies';

/*
* *****************************  API  **********************
* */

/**
 * @param district_id {Number}
 * @param page {Number}
 * @param count {Number}
 *
 * @return Promise
 * */
export function getAllActiveAgencies(district_id, page, count = 24) {
    const data = {district_id, page, count};
    const path = '/search/v1/getAllActiveAgencies?' + httpBuildQuery(data);

    const cacheKey = getCacheKey(cacheTable, 'activeAgencies', 'hash', [district_id, md5(path)]);
    const cacheTTL = 10 * 60;

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param city_id {number}
 * @param district_id {nullable|Array}
 * @param count {Number}
 *
 * @return Promise<Array> => {id, name, address, website, slogan, avatar}
 * */
export function getProminentAgencies(city_id, district_id = null, count = 4) {
    let path = '/search/v1/prominentAgencies?';

    const data = {
        city_id: city_id,
        district_id: district_id,
        count: count
    };

    path = path + httpBuildQuery(data);

    //const cacheKey = ''; // if isEmpty do not cache
    const cacheKey = getCacheKey(cacheTable, 'prominentAgencies','hash', [md5(path)]);
    const cacheTTL = 5 * 60; // second

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            const agencies = sortShuffleAgenciesVipAccounts(result.agencies);

            resolve({agencies});
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param city_id {number}
 * @param district_id {nullable|Array}
 * @param count {Number}
 *
 * @return Promise<Array> => {id, name, address, website, slogan, avatar}
 * */
export function getMostActiveAgencies(city_id, district_id = null, count = 4) {
    let path = '/search/v1/mostActiveAgencies?';

    const data = {
        city_id: city_id,
        district_id: district_id,
        count: count
    };

    path = path + httpBuildQuery(data);

    const cacheKey = getCacheKey(cacheTable, 'mostActiveAgencies', 'hash', [md5(path)]);
    const cacheTTL = 5 * 60; // second

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            const agencies = sortShuffleAgenciesVipAccounts(result.agencies);

            resolve({agencies});
        }).catch(err => {
            reject(err)
        })
    })
}

function sortShuffleAgenciesVipAccounts(agencies) {
    let vip = [];
    let others = [];

    if (agencies && agencies.length) {
        for (const agency of agencies) {
            if (agency.is_vip) {
                vip.push(agency)
            } else {
                others.push(agency)
            }
        }
    }

    if (vip.length) {
        vip = shuffle(vip);
    }

    return [...vip, ...others];
}

function shuffle(array) {
    const newArray = [...array]
    const length = newArray.length

    for (let start = 0; start < length; start++) {
        const randomPosition = Math.floor((newArray.length - start) * Math.random())
        const randomItem = newArray.splice(randomPosition, 1)

        newArray.push(...randomItem)
    }

    return newArray
}

/**
 * @param agency_id {number|required}
 *
 * @return Promise
 * */
export function agencyContactInfo(agency_id) {
    const path = '/v1/agencies/' + agency_id + '/contactInfo';

    const cacheKey = getCacheKey(cacheTable, 'contactInfo', 'agency', [agency_id]);
    const cacheTTL = 60 * 60; // second

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result);
        }).catch(err => {
            reject(err)
        })
    })
}


/*
* *****************************  Helpers  **********************
* */

export function getLogo(agency_id = null, updated_at = null) {
    if (!isEmpty(agency_id)) {
        return getFile('/agencies/' + agency_id + '/logo.jpg' + (!isEmpty(updated_at) ? '?' + updated_at : ''));
    }

    return '/_img/default/logo.jpg';
}

export function getAgencyProfileUrl(contactInfo) {
    const {agency_username, agency_city_name, agency_district_name, agency_slug, agency_name} = contactInfo;
    let path = '/';

    if (!isEmpty(agency_username)) {
        path = path + agency_username;
    } else {
        path = path + ('املاک-' + str_replace(' ', '-', agency_city_name));
        path = path + ('/مشاورین-املاک');
        path = path + ('/' + str_replace(' ', '-', agency_district_name));
        path = path + '/a-' + agency_slug;
        path = path + '-' + str_replace(' ', '-', agency_name);
    }

    return path;
}